import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange } from '../../../actions/index';

import Grid from '@material-ui/core/Grid';
import Slider from '@material-ui/core/Slider';
import CloseIcon from '@material-ui/icons/Close';

import { _ } from '../../../functions/translator.js';
import { FilterActions } from '../../../constants/constants.js';

class VolumeDropdown extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            defaultValue: null,
            initialValues: this.getVolumeMinAndMax(),
            volumeValues: this.getVolumeMinAndMax(),
        }
    }

    handleVolumeChange = (event, newValue) => {
        this.setState({ volumeValues: newValue });
        this.props.filterChange(FilterActions.VOLUME, newValue);
    };

    handleClose = (event) => {
        this.props.filterChange(FilterActions.VOLUME, this.state.defaultValue);
        this.props.closeCallback(event);
    }

    getVolumeMinAndMax = () => {
        let min = 0;
        let max = 1;
        for (const figureData of Object.values(this.props.figuresData)) {
            const volume = figureData.attributes.real_volume;
            if (!volume) continue;
            if (min > volume) min = volume;
            if (max < volume) max = volume;
        }
        return [min, max];
    }

    render() {
        return(
            <div className={this.props.extraClass}>
                <p className='text'>
                    { _('Volumen') } (m3)
                    <CloseIcon className='float-right cursor-pointer' data-type='volume' onClick={this.handleClose}/>
                </p>
                <Grid container spacing={2}>
                    <Grid item>
                        {Math.round(this.state.initialValues[0])}
                    </Grid>
                    <Grid item xs>
                        <Slider
                            min={this.state.initialValues[0]}
                            max={this.state.initialValues[1]}
                            value={this.state.volumeValues}
                            onChange={this.handleVolumeChange}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${Math.round(value)}`}
                        />
                    </Grid>
                    <Grid item>
                        {Math.round(this.state.initialValues[1])}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps( state ){
    return {
        figuresData : state.projectData.figures
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        filterChange     : filterChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(VolumeDropdown);